const config = {
  serverUrl: process.env.REACT_APP_SHORTENER_SERVER || 'http://localhost:5002',
  clientUrl: process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000',
  isProduction: process.env.NODE_ENV === 'production'
};

if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    config.serverUrl = 'http://localhost:5002';
    config.clientUrl = `http://localhost:${window.location.port || '3000'}`;
    config.isProduction = false;
  } else if (hostname.includes('link2.do') || hostname.includes('')) {
    config.serverUrl = 'https://link2do-shortener-d85fc2484e34.herokuapp.com';
    config.clientUrl = 'https://link2.do';
    config.isProduction = true;
  } else {
    config.clientUrl = `${window.location.protocol}//${hostname}${window.location.port ? ':' + window.location.port : ''}`;
  }
}

export default config;